<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder  * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<div>
  @if(isLoggedIn) {

  <div class="row casi-header">
    <app-header></app-header>
  </div>
  <div class="row casi-body">
    <router-outlet />
    <casi-loading-indicator />

  </div>
  } @else {
  <div class="container-fluid" style="padding: 0; ">
    <app-header></app-header>
    <router-outlet />
    <casi-loading-indicator />
    <app-footer style="margin-top: auto;"></app-footer>
  </div>

  <!-- <div style="display: flex; flex-direction: column; min-height: 100vh;">
    <main class="main">
      <div class="content">
        <div class="left-side">
        </div>
      </div>
    </main>

  </div> -->
  }
</div>
